export enum ResultType {
  HOTEL = 'HOTEL',
  MESSAGING = 'MESSAGING',
  CAROUSEL = 'CAROUSEL',
  LIST_TITLE = 'LIST_TITLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION'
}
